export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/worker.2d583274.worker.js");
}
